import { useState } from "react";
import TextField from "@mui/material/TextField";
import styles from "./styles";
import { dateFormat } from "@utils/viewUtility";
import moment, { Moment } from "moment";
import useStyles from "@hooks/useStyle";
import TodayIcon from "@mui/icons-material/Today";
import { MvDatePickerPropsInterface } from "@mv-components/types";
import { Typography } from "..";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DesktopDatePicker, DesktopDateTimePicker, MobileDatePicker, MobileDateTimePicker } from "@mui/x-date-pickers";

export const DateTime = (props: MvDatePickerPropsInterface) => {
	const {
		extraClass,
		onChange,
		itemKey,
		label,
		format = dateFormat.formatClient,
		value: _value,
		helperText,
		disableFuture,
		disablePast,
		disabled,
		timePicker,
		noInput,
		mobileDatePicker,
		targetElementClass,
		targetElementContainerClass,
		onAccept,
		maxDate,
		className,
	} = props;
	const [open, setOpen] = useState(false);
	const { classes, cx } = useStyles(styles) as any;
	const handleInputClick = () => {
		if (disabled) return;
		setOpen(true);
	};

	// TODO[Y]
	// let value = _value;
	// useEffect(() => {
	//   value = _value ? moment(_value).format(format) : _value;
	// }, []);

	const value = _value ? moment(_value).format(format) : _value;

	let RenderComponent = timePicker ? DesktopDateTimePicker : DesktopDatePicker;
	if (mobileDatePicker) {
		RenderComponent = timePicker ? MobileDateTimePicker : MobileDatePicker;
	}

	return (
		<LocalizationProvider dateAdapter={AdapterDateFns}>
			<RenderComponent
				open={open}
				// autoOk
				maxDate={maxDate}
				// variant="inline"
				InputAdornmentProps={{ position: "end" }}
				label={label}
				inputFormat={format}
				value={value}
				disableFuture={disableFuture}
				disablePast={disablePast}
				disabled={disabled}
				onAccept={onAccept}
				onClose={() => {
					setOpen(false);
				}}
				renderInput={(inputProps: any) => {
					if (noInput) {
						return (
							<div className={targetElementContainerClass} onClick={handleInputClick}>
								<Typography className={cx(classes.t14Bold, classes.tLink, targetElementClass)}>
									{value}
								</Typography>
								<TodayIcon className={classes.dateIconClass} color="primary" />
								<input
									type="input"
									style={{ display: "none" }}
									ref={inputProps.inputRef}
									value={value}
								/>
							</div>
						);
					}
					return (
						<TextField
							onClick={handleInputClick}
							variant="outlined"
							{...inputProps}
							inputProps={{ ...inputProps.inputProps, value }}
							error={false}
							helperText={helperText}
							className={cx(extraClass, className ? classes[className] : "", classes.rootInput)}
						/>
					);
				}}
				onChange={(date: Moment | null) => {
					onChange(itemKey)(date);
				}}
			/>
		</LocalizationProvider>
	);
};

export default DateTime;
